<template>
  <div class="ip-input">
    <input
      :id="`ip1-${uid}`"
      v-model="ip1"
      autocomplete="off"
      ref="input1"
      @input="handleInput(1, ip1)"
      @keydown="handleKeyDown($event, 1)"
    />
    <span>.</span>
    <input
      :id="`ip2-${uid}`"
      v-model="ip2"
      autocomplete="off"
      ref="input2"
      @input="handleInput(2, ip2)"
      @keydown="handleKeyDown($event, 2)"
    />
    <span>.</span>
    <input
      :id="`ip3-${uid}`"
      v-model="ip3"
      autocomplete="off"
      ref="input3"
      @input="handleInput(3, ip3)"
      @keydown="handleKeyDown($event, 3)"
    />
    <span>.</span>
    <input
      :id="`ip4-${uid}`"
      v-model="ip4"
      autocomplete="off"
      ref="input4"
      @input="handleInput(4, ip4)"
      @keydown="handleKeyDown($event, 4)"
    />
  </div>
</template>

<script>
export default {
  name: "ThirdPartyIpAddrInput",
  props: {
    IP: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uid: Math.random().toString(36).slice(2, 10),
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
    };
  },
  watch: {
    IP: {
      immediate: true,
      handler(val) {
        this.fillByIP(val);
      },
    },
    ip1() {
      this.emitIp();
    },
    ip2() {
      this.emitIp();
    },
    ip3() {
      this.emitIp();
    },
    ip4() {
      this.emitIp();
    },
  },
  methods: {
    fillByIP(ip) {
      if (!ip) {
        this.ip1 = "";
        this.ip2 = "";
        this.ip3 = "";
        this.ip4 = "";
        return;
      }
      const parts = String(ip).split(".");
      this.ip1 = parts[0] || "";
      this.ip2 = parts[1] || "";
      this.ip3 = parts[2] || "";
      this.ip4 = parts[3] || "";
    },
    isValidIP(ip) {
      const reg =
        /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
      return reg.test(ip);
    },
    getInputEl(index) {
      return document.getElementById(`ip${index}-${this.uid}`);
    },
    handleInput(index, ipValue) {
      if (this.isValidIP(ipValue)) {
        const arr = ipValue.split(".");
        this.ip1 = arr[0];
        this.ip2 = arr[1];
        this.ip3 = arr[2];
        this.ip4 = arr[3];
      } else {
        this[`ip${index}`] = this[`ip${index}`].replace(/[^0-9]/g, "");
        const ip = this[`ip${index}`];
        if (ip.length > 1 && ip[0] === "0") {
          this[`ip${index}`] = ip.slice(1);
        }
        if (Number(ip) > 255) {
          this[`ip${index}`] = "255";
        }
        if (ip.length === 3 || ip[0] === "0") {
          const nextIndex = index + 1;
          if (nextIndex <= 4) {
            this.$refs[`input${nextIndex}`].focus();
          }
        }
      }
    },
    handleKeyDown(event, index) {
      const ip = this[`ip${index}`];
      const currentEl = this.getInputEl(index);
      if (!currentEl) {
        return false;
      }
      if (event.keyCode === 8 && currentEl.selectionStart === 0) {
        const nextIndex = index - 1;
        if (nextIndex >= 1) {
          this.$refs[`input${nextIndex}`].focus();
          const prevEl = this.getInputEl(nextIndex);
          if (prevEl) {
            const len = this[`ip${nextIndex}`].length;
            prevEl.setSelectionRange(len, len);
          }
        }
      } else if (event.keyCode === 46 && ip.length === currentEl.selectionStart) {
        const nextIndex = index + 1;
        if (nextIndex <= 4) {
          this.$refs[`input${nextIndex}`].focus();
          const nextEl = this.getInputEl(nextIndex);
          if (nextEl) {
            nextEl.setSelectionRange(0, 0);
          }
        }
      } else if (event.keyCode === 37 && currentEl.selectionStart === 0) {
        const nextIndex = index - 1;
        if (nextIndex >= 1) {
          this.$refs[`input${nextIndex}`].focus();
          const prevEl = this.getInputEl(nextIndex);
          if (prevEl) {
            const len = this[`ip${nextIndex}`].length;
            prevEl.setSelectionRange(len, len);
          }
        }
      } else if (event.keyCode === 39 && ip.length === currentEl.selectionStart) {
        const nextIndex = index + 1;
        if (nextIndex <= 4) {
          this.$refs[`input${nextIndex}`].focus();
          const nextEl = this.getInputEl(nextIndex);
          if (nextEl) {
            nextEl.setSelectionRange(0, 0);
          }
        }
      } else if (event.keyCode === 110 || event.keyCode === 190) {
        const nextIndex = index + 1;
        if (nextIndex <= 4) {
          this.$refs[`input${nextIndex}`].focus();
        }
      } else {
        return false;
      }
    },
    emitIp() {
      const ip = `${this.ip1}.${this.ip2}.${this.ip3}.${this.ip4}`;
      this.$emit("changeIP", ip);
    },
  },
};
</script>

<style scoped>
.ip-input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 10px;
  box-sizing: border-box;
  font-size: 16px;
}

.ip-input input {
  width: 30px;
  height: 90%;
  border: none;
  outline: none;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

.ip-input span {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/user/eval_jees/third_party/input.vue